import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Space, Typography, Tag } from 'antd';
import {
    CheckCircleOutlined,
    EditOutlined,
    ExclamationCircleOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';


const SkillsAlert = ({ skills = [] }) => {
    const navigate = useNavigate();
    const [isExpanded, setIsExpanded] = useState(false);

    const handleEditSkills = () => {
        navigate('/expert-skills');
    };



    // Extract all subcategory names from the nested structure
    const selectedSkills = skills.flatMap(category =>
        category.subCategories ? category.subCategories.map(sub => sub.name) : []
    );

    const totalSelections = selectedSkills.length;
    const hasSkills = totalSelections > 0;

    // If no interests, show a compact alert
    if (!hasSkills) {
        return (
            <div style={{
                background: '#fff7e6', // Light orange background for warning
                border: '1px solid #ffd591',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '24px',
                boxShadow: '0 2px 8px rgba(250, 140, 22, 0.1)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <ExclamationCircleOutlined
                            style={{ fontSize: '20px', color: '#B17F14', flexShrink: 0 }}
                        />
                        <div>
                            <div style={{
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#000'
                            }}>
                                No Focus Areas Selected
                            </div>
                        </div>
                    </div>
                    <Button
                        type="primary"
                        size="small"
                        onClick={handleEditSkills}
                        style={{ borderRadius: '6px', fontWeight: '500' }}
                        icon={<EditOutlined />}
                    >
                        Select Skills
                    </Button>
                </div>
            </div>
        );
    }

    // If Skills exist, show the compact alert
    return (
        <div style={{
            background: '#F6EFDD', // Light blue background for an alert/info feel
            border: '1px solid #E7D3A8',
            borderRadius: '12px',
            padding: '16px',
            marginBottom: '24px',
            boxShadow: '0 2px 8px rgba(24, 144, 255, 0.1)'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <CheckCircleOutlined
                        style={{ fontSize: '20px', color: '#9A6B0E', flexShrink: 0 }}
                    />
                    <div>
                        <div style={{
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#000'
                        }}>
                            🎯 Your Focus Areas ({totalSelections} Selected)
                        </div>
                        {isExpanded && (
                            <div style={{
                                fontSize: '12px',
                                color: '#595959',
                                marginTop: '8px',
                                marginBottom: '12px'
                            }}>
                                These Skills shape your personalized Experties recommendations.
                            </div>
                        )}
                    </div>
                </div>
                
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        type="text"
                        size="small"
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{ 
                            fontWeight: '500', 
                            color: '#9A6B0E',
                            padding: '0 8px'
                        }}
                    >
                        {isExpanded ? 'Show Less' : 'Show More'}
                    </Button>
                    <Button
                        type="default"
                        size="small"
                        onClick={handleEditSkills}
                        style={{ borderRadius: '6px', fontWeight: '500' }}
                        icon={<EditOutlined />}
                    >
                        Edit
                    </Button>
                </div>
            </div>

            {/* Expanded content - only show when expanded */}
            {isExpanded && (
                <>
                    {/* Interest Tags (Subcategories) */}
                    <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                        <Space wrap size={[8, 8]}>
                            {selectedSkills.map((skillName, index) => (
                                <Tag
                                    key={index}
                                    color="gold"
                                    style={{
                                        borderRadius: '16px',
                                        padding: '4px 10px',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        background: '#f0f7ff',
                                        borderColor: '#E7D3A8',
                                    }}
                                >
                                    {skillName}
                                </Tag>
                            ))}
                        </Space>
                    </div>

               
                </>
            )}
        </div>
    );
};

SkillsAlert.propTypes = {
    skills: PropTypes.arrayOf(
        PropTypes.shape({
            subCategories: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string.isRequired,
                })
            )
        })
    ).isRequired
};

export default SkillsAlert;